// 设备管理接口
import request from '@/utils/request.ts'

export const getdatalist = (params: any) =>
  request({
    url: '/student/getStudentList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const adddata = (params: any) =>
  request({
    url: '/student/addStudent',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getorginizlist = (params: any) =>
  request({
    url: '/users/getOrganInfoByID',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

export const getinfodata = (params: any) =>
  request({
    url: '/student/getStudentById',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const updateinfo = (params: any) =>
  request({
    url: '/student/updateStudent',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const uploadfile = (params: any) =>
  request({
    url: '/student/uploadfile',
    method: 'post',
    data: params,
  })
export const gettissuelist = (data: any) =>
  request({
    url: '/organization/getOrganList',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })